module.exports = __webpack_public_path__ + "img/bed-front.5c8b5b63.svg";